import { InviteTeamListItem } from "."

export const CollaborateWithOthers = ({ forConfirmed }) => {
    return <InviteTeamListItem forConfirmed={forConfirmed} />
}